import { mapGetters } from 'vuex';
import _ from 'lodash'

export default {
    computed: {
        ...mapGetters('user', [ // 去vux裡拿出ID來判斷
            'MemberID',
        ]),
    },
    watch: {
        MemberID() {
            this.throttledInitUser();
        },
    },
    methods: {
        throttledInitUser: _.debounce(function () { // 在0.1秒內不管呼多少次只取一次
            this.initUser();
        }, 100),
        
        // overwrite this in component
        initUser() { // 在其他component覆蓋這個fn.
            
        },
    },
}